import CarsCardSkeleton from "@/components/ui/loaders/buy-cars/CarsCardSkeleton";

const SuggestedLoader = () => {
  return (
    <>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
        {Array.from({ length: 6 }).map((_, index) => (
          <CarsCardSkeleton key={index} />
        ))}
      </div>
    </>
  );
};

export default SuggestedLoader;
